import { getLastIndexOf } from '@/modules/globalModule/components/helperMethods';
import { PackageT } from '@/modules/nodesCanvasModule/components/storeClasses/packageT';

export interface CustomPackageText {
  launchFileImports: string;
  launchFileText: string;
  packageXmlExtraTags: string;
  packageXmlConfig: string;
  cMakeListsText: string;
}

export const defaultCustomPkgText: CustomPackageText = {
  launchFileImports: '',
  launchFileText: '',
  packageXmlExtraTags: '',
  packageXmlConfig: '',
  cMakeListsText: ''
};

export const processCustomLaunchFile = (
  pkg: PackageT,
  editorText: string
): CustomPackageText => {
  const packageCustomText = pkg.customText;

  if (
    editorText.includes('    # customize launch file below\n') &&
    editorText.includes('    # end launch file customization')
  ) {
    packageCustomText.launchFileText = editorText
      .slice(
        getLastIndexOf(editorText, '    # customize launch file below\n'),
        editorText.indexOf('    # end launch file customization')
      )
      .trimEnd();
  }
  if (
    editorText.includes('# customize launch file imports below\n') &&
    editorText.includes('# end launch file import customization')
  ) {
    packageCustomText.launchFileImports = editorText
      .slice(
        getLastIndexOf(editorText, '# customize launch file imports below\n'),
        editorText.indexOf('# end launch file import customization')
      )
      .trimEnd();
  }

  return packageCustomText;
};

export const processCustomPackageXml = (
  pkg: PackageT,
  editorText: string
): CustomPackageText => {
  const packageCustomText = pkg.customText;

  if (
    editorText.includes('  <!-- Add additional package.xml tags below -->\n') &&
    editorText.includes('  <!-- End custom package.xml tags -->')
  ) {
    packageCustomText.packageXmlExtraTags = editorText
      .slice(
        getLastIndexOf(
          editorText,
          '  <!-- Add additional package.xml tags below -->\n'
        ),
        editorText.indexOf('  <!-- End custom package.xml tags -->')
      )
      .trimEnd();
  }

  if (
    editorText.includes('  <!-- Edit package configuration below -->\n') &&
    editorText.includes('  <!-- End package configuration customization -->')
  ) {
    packageCustomText.packageXmlConfig = editorText
      .slice(
        getLastIndexOf(
          editorText,
          '  <!-- Edit package configuration below -->\n'
        ),
        editorText.indexOf('  <!-- End package configuration customization -->')
      )
      .trimEnd();
  }
  return packageCustomText;
};

export const processCustomCmakeLists = (pkg: PackageT, editorText: string) => {
  const packageCustomText = pkg.customText;
  if (
    editorText.includes('# customize CMakeLists.txt below\n') &&
    editorText.includes('# end CMakeLists.txt customization')
  ) {
    packageCustomText.cMakeListsText = editorText
      .slice(
        getLastIndexOf(editorText, '# customize CMakeLists.txt below\n'),
        editorText.indexOf('# end CMakeLists.txt customization')
      )
      .trimEnd();
  }
  return packageCustomText;
};
